export interface Portfolio {
  name: string;
  good: Number;
  bad: Number;
  median: Number;
}

export const MONTHLY_PLAN_MIN = 50;
export const MONTHLY_PLAN_MIN_NEW = 25;
export const MONTHLY_PLAN_MAX = 5000;

export const FIRST_INVESTMENT_MIN = 500;
export const FIRST_INVESTMENT_MIN_NEW = 25;
export const FIRST_INVESTMENT_MAX = 999_999_999;

export interface ChartHeaderProps {
  startAmount: number;
  monthlyAmount: number;
  portfolio: number;
  duration: number;
  changeStartAmount: (amount: number) => void;
  changeMonthlyAmount: (amount: number) => void;
  changePortfolio: (portfolio: number) => void;
  changeDuration: (duration: number) => void;
  hasMoneyMarket: boolean;
}

export interface ChartBodyProps {
  startAmount: number;
  monthlyAmount: number;
  portfolio: number;
  duration: number;
  openDetailsModal: () => void;
  hasMoneyMarket: boolean;
}

export interface Portfolio {
  name: string;
  good: Number;
  bad: Number;
  median: Number;
}
